import Asih1 from "./asih (1).webp";
import Asih2 from "./asih (2).webp";

const asih = [Asih1, Asih2];

export default asih;
